import React, {useEffect, useRef} from "react";
import gsap, {Power0} from "gsap";

import styles from "./Graph.module.scss";
import {isInViewport} from "../../Functions";

export default function EvolutionRemote() {
    const element = useRef(null);

    useEffect(() => {

        const lines = element.current.querySelectorAll('.line');

        Object.values(lines).map(line =>

            gsap.set(line, {
                strokeDasharray: line.getTotalLength(),
                strokeDashoffset: line.getTotalLength(),
            })
        );

        if (element.current && !element.current.classList.contains('animated')) {
            window.addEventListener('scroll', () => {
                if (isInViewport(element.current)) {
                    gsap.to(lines, 3, {
                        ease: Power0.easeOut,
                        strokeDashoffset: 0
                    });

                    element.current.classList.add('animated');
                }
            })
        }
    }, []);

    const svg = `<svg width="960px" height="499px" viewBox="0 0 960 499" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <g transform="translate(0.000000, -2.000000)">
            <g transform="translate(60.000000, 5.500000)">
                <rect fill-opacity="0.20329146" fill="#D8D8D8" x="0" y="371" width="900" height="90"></rect>
                <rect fill="#F7F7F7" x="0" y="279" width="900" height="90"></rect>
                <rect fill="#F7F7F7" x="0" y="187" width="900" height="90"></rect>
                <rect fill="#F7F7F7" x="0" y="95" width="900" height="90"></rect>
                <rect fill="#F7F7F7" x="0" y="3" width="900" height="90"></rect>
            </g>
            <g transform="translate(169.500000, 0.000000)">
                <polyline stroke="#D8D8D8" stroke-width="14" opacity="0.797575451" stroke-linecap="round" stroke-linejoin="round" points="5 33 85.5565186 51.344635 159.70752 83.7849121"></polyline>
                <path d="M620.584229,184.651672 L698,171" stroke="#D8D8D8" stroke-width="14" opacity="0.797575451" stroke-linecap="round" stroke-linejoin="round"></path>
                <polyline class="line" stroke="#1C246B" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" points="5 33 85.5565186 51.344635 159.70752 83.7849121 230.720215 91.5387573 307.319275 109.496582 389.464783 135.045593 468.217529 151.094727 544.891968 216.516235 620.584229 184.651672 698 171"></polyline>
                <text font-family="OpenSans-Bold, Open Sans" font-size="18" font-weight="bold" line-spacing="16" fill="#000000">
                    <tspan x="0.5" y="19.5">GBR</tspan>
                </text>
            </g>
            <g transform="translate(156.500000, 38.000000)">
                <path d="M402.367187,48.960228 L481.217529,12" stroke="#D8D8D8" stroke-width="14" opacity="0.796898978" stroke-linecap="round" stroke-linejoin="round"></path>
                <polyline class="line" stroke="#417505" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" points="18 19 94.5 12 175.311584 76.5 248.156433 121.045593 481.217529 12 557.891968 12 633.584229 47.6972046 711 0.5"></polyline>
                <text font-family="OpenSans-Bold, Open Sans" font-size="18" font-weight="bold" line-spacing="16" fill="#000000">
                    <tspan x="0.5" y="50.5">AUS</tspan>
                </text>
            </g>
            <g transform="translate(251.500000, 144.000000)">
                <polyline stroke="#D8D8D8" stroke-width="14" opacity="0.799064273" stroke-linecap="round" stroke-linejoin="round" points="152.599426 37.3361511 77.7075195 0.350311279 0.353759766 0.350311279"></polyline>
                <path d="M537.368893,124.26469 L538.176371,124.094439" stroke="#D8D8D8" stroke-width="14" opacity="0.796792893" stroke-linecap="round" stroke-linejoin="round"></path>
                <polyline class="line" stroke="#D0021B" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" points="77 0.350311279 152.599426 37.3361511 229.899139 81 308.145874 102 460.709106 130 537.143494 124.605194 616 107.35849"></polyline>
                <text font-family="OpenSans-Bold, Open Sans" font-size="18" font-weight="bold" line-spacing="16" fill="#000000">
                    <tspan x="603.5" y="140.5">USA</tspan>
                </text>
            </g>
            <g transform="translate(328.500000, 91.000000)">
                <polyline class="line" stroke="#F8E71C" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" points="0 46.0039368 75.8044128 73.0773315 152.899139 134 231.145874 122.452271 308 90.664093 384.646851 76.905365 461.584229 14.2362671 539 28.8401184"></polyline>
                <text font-family="OpenSans-Bold, Open Sans" font-size="18" font-weight="bold" line-spacing="16" fill="#000000">
                    <tspan x="544.5" y="19.5">SWE</tspan>
                </text>
            </g>
            <g transform="translate(126.500000, 236.000000)">
                <polyline stroke="#D8D8D8" stroke-width="14" opacity="0.802645002" stroke-linecap="round" stroke-linejoin="round" points="201.476593 26.2860718 124.5 4 48 -9.09494702e-13"></polyline>
                <polyline class="line" stroke="#2B6FB6" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" points="48 -1.8834153e-13 124.5 4 202 26.4024353 355.224854 131.544281 432.464783 144.152435 587.891968 91.7581177"></polyline>
                <text font-family="OpenSans-Bold, Open Sans" font-size="18" font-weight="bold" line-spacing="16" fill="#000000">
                    <tspan x="0.5" y="24.5">FRA</tspan>
                </text>
            </g>
            <g transform="translate(89.500000, 387.000000)">
                <polyline stroke="#D8D8D8" stroke-width="14" opacity="0.801969982" stroke-linecap="round" stroke-linejoin="round" points="237.690002 15.8703003 162.35376 0.297332764 85 35.2542114"></polyline>
                <polyline class="line" stroke="#1D9BD8" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" points="7.43035889 70.2110901 162.35376 0.297332764 315 31.8268127"></polyline>
                <text font-family="OpenSans-Bold, Open Sans" font-size="18" font-weight="bold" line-spacing="16" fill="#000000">
                    <tspan x="0.5" y="49.5">ITA</tspan>
                </text>
            </g>
            <g transform="translate(0.000000, 1.500000)" fill="#000000" font-family="OpenSans-Bold, Open Sans" font-size="16" font-weight="bold" line-spacing="16">
                <text>
                    <tspan x="0" y="474">0 </tspan>
                    <tspan x="14.3984375" y="474.335938" font-family="OpenSans-Regular, Open Sans" font-weight="normal">%</tspan>
                </text>
                <text>
                    <tspan x="0" y="383">10 </tspan>
                    <tspan x="23.53125" y="383.335937" font-family="OpenSans-Regular, Open Sans" font-weight="normal">%</tspan>
                </text>
                <text>
                    <tspan x="0" y="292">20 </tspan>
                    <tspan x="23.53125" y="292.335937" font-family="OpenSans-Regular, Open Sans" font-weight="normal">%</tspan>
                </text>
                <text>
                    <tspan x="0" y="199">30 </tspan>
                    <tspan x="23.53125" y="199.335937" font-family="OpenSans-Regular, Open Sans" font-weight="normal">%</tspan>
                </text>
                <text>
                    <tspan x="0" y="109">40 </tspan>
                    <tspan x="23.53125" y="109.335938" font-family="OpenSans-Regular, Open Sans" font-weight="normal">%</tspan>
                </text>
                <text>
                    <tspan x="0" y="17">50 </tspan>
                    <tspan x="23.53125" y="17.3359375" font-family="OpenSans-Regular, Open Sans" font-weight="normal">%</tspan>
                </text>
            </g>
            <g transform="translate(59.000000, 483.500000)" fill="#000000" font-family="OpenSans-Bold, Open Sans" font-size="14" font-weight="bold" line-spacing="16">
                <text>
                    <tspan x="15.8764648" y="13.0361328">Fév.</tspan>
                </text>
                <text>
                    <tspan x="89.3457031" y="13.0361328">Mars</tspan>
                </text>
                <text>
                    <tspan x="167.569336" y="13.0361328">Avril</tspan>
                </text>
                <text>
                    <tspan x="247.867676" y="13.0361328">Mai</tspan>
                </text>
                <text>
                    <tspan x="324.177246" y="13.0361328">Juin</tspan>
                </text>
                <text>
                    <tspan x="399.509277" y="13.0361328">Juill.</tspan>
                </text>
                <text>
                    <tspan x="475.029297" y="13.0361328">Août</tspan>
                </text>
                <text>
                    <tspan x="551.376465" y="13.0361328">Sept.</tspan>
                </text>
                <text>
                    <tspan x="631.626953" y="13.0361328">Oct.</tspan>
                </text>
                <text>
                    <tspan x="706.829102" y="13.0361328">Nov.</tspan>
                </text>
                <text>
                    <tspan x="784.919434" y="13.0361328">Déc.</tspan>
                </text>
            </g>
        </g>
    </g>
</svg>`;

    const legend = `
<svg width="205px" height="323px" viewBox="0 0 205 323" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <g transform="translate(-1139.000000, -2421.000000)">
            <g transform="translate(20.000000, 2190.000000)">
                <g transform="translate(99.000000, 222.500000)">
                    <g transform="translate(1021.500000, 5.500000)">
                        <text font-family="OpenSans-Bold, Open Sans" font-size="14" font-weight="bold" line-spacing="16" fill="#000000">
                            <tspan x="49.5" y="15.5">AUS</tspan>
                            <tspan x="78.6904297" y="17.4638672" font-size="12"> </tspan>
                            <tspan x="82.6396484" y="17.4638672" font-family="OpenSans-Regular, Open Sans" font-size="12" font-weight="normal">(autodéclaré)</tspan>
                        </text>
                        <path d="M0.805603027,9 L40.805603,9" stroke="#417505" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"></path>
                        <text font-family="OpenSans-Bold, Open Sans" font-size="14" font-weight="bold" line-spacing="16" fill="#000000">
                            <tspan x="49.5" y="45.5">SWE</tspan>
                            <tspan x="79.8251953" y="47.4638672" font-size="12"> </tspan>
                            <tspan x="83.7744141" y="47.4638672" font-family="OpenSans-Regular, Open Sans" font-size="12" font-weight="normal">(autodéclaré)</tspan>
                        </text>
                        <path d="M0.805603027,39 L40.805603,39" stroke="#F8E71C" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"></path>
                        <text font-family="OpenSans-Bold, Open Sans" font-size="14" font-weight="bold" line-spacing="16" fill="#000000">
                            <tspan x="49.5" y="75.5">GBR</tspan>
                            <tspan x="79.5244141" y="77.4638672" font-size="12"> </tspan>
                            <tspan x="83.4736328" y="77.4638672" font-family="OpenSans-Regular, Open Sans" font-size="12" font-weight="normal">(déclaré par</tspan>
                            <tspan x="51.5703125" y="93.4638672" font-family="OpenSans-Regular, Open Sans" font-size="12" font-weight="normal">les employeurs)</tspan>
                        </text>
                        <path d="M0.805603027,69 L40.805603,69" stroke="#1C246B" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"></path>
                        <text font-family="OpenSans-Bold, Open Sans" font-size="14" font-weight="bold" line-spacing="16" fill="#000000">
                            <tspan x="49.194397" y="125.5">USA</tspan>
                            <tspan x="78.3848267" y="127.463867" font-size="12"> </tspan>
                            <tspan x="82.3340454" y="127.463867" font-family="OpenSans-Regular, Open Sans" font-size="12" font-weight="normal">(« en raison de la </tspan>
                            <tspan x="51.2647095" y="143.463867" font-family="OpenSans-Regular, Open Sans" font-size="12" font-weight="normal">pandémie de coronavirus », </tspan>
                            <tspan x="51.2647095" y="159.463867" font-family="OpenSans-Regular, Open Sans" font-size="12" font-weight="normal">autodéclaré)</tspan>
                        </text>
                        <path d="M0.5,119 L40.5,119" stroke="#D0021B" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"></path>
                        <text font-family="OpenSans-Bold, Open Sans" font-size="14" font-weight="bold" line-spacing="16" fill="#000000">
                            <tspan x="49.5" y="195.5">FRA</tspan>
                            <tspan x="77.3232422" y="197.463867" font-size="12"> </tspan>
                            <tspan x="81.2724609" y="197.463867" font-family="OpenSans-Regular, Open Sans" font-size="12" font-weight="normal">(déclaré par</tspan>
                            <tspan x="51.5703125" y="213.463867" font-family="OpenSans-Regular, Open Sans" font-size="12" font-weight="normal">les employeurs)</tspan>
                        </text>
                        <path d="M0.805603027,189 L40.805603,189" stroke="#2B6FB6" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"></path>
                        <text font-family="OpenSans-Bold, Open Sans" font-size="14" font-weight="bold" line-spacing="16" fill="#000000">
                            <tspan x="49.5" y="245.5">ITA</tspan>
                            <tspan x="73.1396484" y="247.463867" font-size="12"> </tspan>
                            <tspan x="77.0888672" y="247.463867" font-family="OpenSans-Regular, Open Sans" font-size="12" font-weight="normal">(déclaré par</tspan>
                            <tspan x="51.5703125" y="263.463867" font-family="OpenSans-Regular, Open Sans" font-size="12" font-weight="normal">les employeurs)</tspan>
                        </text>
                        <path d="M0.805603027,239 L40.805603,239" stroke="#1D9BD8" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"></path>
                        <text font-family="OpenSans-Regular, Open Sans" font-size="12" font-weight="normal" line-spacing="16" fill="#000000">
                            <tspan x="49.5" y="291.5">Fermeture des lieux de </tspan>
                            <tspan x="49.5" y="307.5">travail (sauf travailleurs </tspan>
                            <tspan x="49.5" y="323.5">essentiels)</tspan>
                        </text>
                        <path d="M5.80560303,289 L35.805603,289" stroke="#D8D8D8" stroke-width="12" opacity="0.80048116" stroke-linecap="round" stroke-linejoin="round"></path>
                    </g>
                </g>
            </g>
        </g>
    </g>
</svg>`;

    return (
        <div className={styles.Main} ref={element}>
            <div dangerouslySetInnerHTML={{__html: svg}} className={styles.Graph}/>

            <div dangerouslySetInnerHTML={{__html: legend}} className={styles.Legend}/>
        </div>
    )
}
